"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class EditableWidget extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      editing: false
    });

    _defineProperty(this, "onAdd", props => {
      console.log('editableWidget:add', props);

      if (this.props.onAdd) {
        this.props.onAdd(props);
      }
    });

    _defineProperty(this, "onRemove", props => {
      console.log('editableWidget:remove', props);

      if (this.props.onRemove) {
        this.props.onRemove(props);
      }
    });

    _defineProperty(this, "onEdit", props => {
      console.log('editableWidget:edit', props);
      this.setState({
        editing: true
      });
    });

    _defineProperty(this, "onSave", props => {
      console.log('editableWidget:save', props);
      this.setState({
        editing: false
      });

      if (this.props.onSave) {
        this.props.onSave(props);
      }
    });

    _defineProperty(this, "getUiSchema", () => {
      const _this$props = this.props,
            uiSchema = _this$props.uiSchema,
            expanded = _this$props.expanded,
            editable = _this$props.editable,
            removable = _this$props.removable,
            addable = _this$props.addable,
            style = _this$props.style;
      return _extends({}, uiSchema, {
        "ui:style": style,
        "ui:options": {
          "expanded": expanded,
          "editable": editable,
          "addable": addable,
          "removable": removable
        }
      });
    });

    _defineProperty(this, "getFormData", () => {
      const _this$props2 = this.props,
            formData = _this$props2.formData,
            widgetType = _this$props2.widgetType,
            widgetSize = _this$props2.widgetSize,
            title = _this$props2.title,
            description = _this$props2.description,
            icon = _this$props2.icon,
            imageUrl = _this$props2.imageUrl;
      let image;

      if (imageUrl) {
        image = {
          mediaId: true,
          media: {
            imageUrl: imageUrl
          }
        };
      }

      return _extends({
        widgetType: widgetType,
        widgetSize: widgetSize,
        title: title,
        description: description,
        icon: icon,
        image: image
      }, formData);
    });

    _defineProperty(this, "getLayouts", () => {
      const editing = this.state.editing;
      const _this$props3 = this.props,
            widgetTemplate = _this$props3.widgetTemplate,
            widgetEditor = _this$props3.widgetEditor;
      let layouts = {
        "widget": _.LayoutWidget,
        "widget-header": _.LayoutWidgetHeader,
        "widget-body": () => {
          return this.props.children;
        }
      };

      if (editing && widgetEditor) {
        layouts['widget-header'] = () => {
          return false;
        };

        layouts['widget-body'] = widgetEditor;
      } else if (editing) {
        layouts['widget-body'] = _.LayoutWidgetEdit;
      } else if (widgetTemplate) {
        layouts['widget-header'] = () => {
          return false;
        };

        layouts['widget-body'] = widgetTemplate;
      }

      return layouts;
    });
  }

  render() {
    const formData = this.getFormData();
    const uiSchema = this.getUiSchema();
    const layouts = this.getLayouts();
    return _react.default.createElement(_.Schema, _extends({}, this.props, {
      formData: formData,
      uiSchema: uiSchema,
      layouts: layouts,
      onAdd: this.onAdd,
      onRemove: this.onRemove,
      onEdit: this.onEdit,
      onSave: this.onSave
    }));
  }

}

_defineProperty(EditableWidget, "defaultProps", {
  addable: false,
  removable: false,
  expanded: false,
  editable: false,
  formData: {},
  schema: {
    type: "object",
    properties: {
      widgetType: {
        type: "string"
      },
      widgetSize: {
        type: "string",
        pattern: "grid",
        enum: ["1:1", "2:1", "3:1", "4:1", "1:2", "2:2", "3:2", "4:2", "1:3", "2:3", "3:3", "4:3", "1:4", "2:4", "3:4", "4:4"]
      },
      title: {
        type: "string"
      },
      description: {
        type: "string",
        format: "email"
      },
      icon: {
        type: "string"
      },
      image: {
        type: "image"
      }
    }
  },
  uiSchema: {
    "ui:layout": "widget",
    "ui:title": {
      "select": "title"
    },
    "ui:description": {
      "select": "description"
    },
    "ui:fieldset": ["header", "body"],
    "header": {
      "ui:layout": "widget-header",
      "ui:fieldset": ["title", "description"],
      "ui:title": {
        "select": "title"
      }
    },
    "body": {
      "ui:layout": "widget-body",
      "ui:fieldset": ["title", "description"]
    },
    "ui:settings": ["widgetSize"]
  }
});

var _default = EditableWidget;
exports.default = _default;
module.exports = exports.default;